export const TEST_MODES = [
  { id: 'unit', label: 'Unit', color: 'var(--color-primary-600)', bg: 'var(--color-primary-050)' },
  { id: 'integration', label: 'Integration', color: 'var(--color-success-600)', bg: 'var(--color-success-050)' }
]

export const DETAIL_TABS = [
  { id: 'config', label: 'Configuration' },
  { id: 'output', label: 'Output' }
]

export const OUTPUT_TABS = [
  { id: 'result', label: 'Result' },
  { id: 'requests', label: 'Requests' },
  { id: 'logs', label: 'Logs' }
]
